export const MailTemplates = {
  path: '/mail-templates',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'mailTemplates',
      component: () => import('pages/mailTemplates/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.mailTemplates.name',
        path: '/mail-templates',
        condition: 'mailTemplate',
      },
    },
    {
      path: 'create',
      name: 'mailTemplates-create',
      component: () => import('pages/mailTemplates/CreatePage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.create',
        parents: [
          {
            title: 'page.mailTemplates.name',
            path: '/mail-templates',
            condition: 'mailTemplate',
          },
        ],
      },
    },
    {
      path: ':id',
      name: 'mailTemplates-id',
      component: () => import('src/pages/mailTemplates/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.mailTemplates.name',
            path: '/mail-templates',
            condition: 'mailTemplate',
          },
        ],
      },
    },
    {
      path: ':id/edit',
      name: 'mailTemplates-id-edit',
      component: () => import('src/pages/mailTemplates/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.edit',
        parents: [
          {
            title: 'page.mailTemplates.name',
            path: '/mail-templates',
            condition: 'mailTemplate',
          },
          {
            title: ':name',
            path: '/mail-templates/:id',
          },
        ],
      },
    },
  ],
};
